import React, { Component } from 'react';
import { connect } from 'react-redux'
import { closePopup } from '../../actions/popup';
import { updateModule } from '../../actions/sidebar';
import update from 'immutability-helper'
import classnames from 'classnames';

@connect(state => ({
    isEditSidebarModuleOpened: state.popup.isEditSidebarModuleOpened,
    module: state.popup.sidebarModule
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
    handleUpdateModule: (module, params, savingUserModule) => {
        dispatch(updateModule(module, params, savingUserModule))
    },
    dispatch
}))
class EditModulePopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            imageBanner : {
                label : null,
                imgsrc : "http://",
                href : "http://",
            },
            htmlBanner : {
                label : null,
                text : null,
            },
            tagReplacer : {
                label : null,
                text : null,
            },
            savingUserModule : false,
        };

        this.handleLabelChange = this.handleLabelChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleBlockIpChange = this.handleBlockIpChange.bind(this);
        this.handleUpdateImageBanner = this.handleUpdateImageBanner.bind(this);
        this.handleUpdateHtmlBanner = this.handleUpdateHtmlBanner.bind(this);
        this.handleUpdateTagReplacer = this.handleUpdateTagReplacer.bind(this);
        this.handleCheckSavingUserModule = this.handleCheckSavingUserModule.bind(this);
        this.handleEditModulePopup = this.handleEditModulePopup.bind(this);
    }

    reInit() {
        this.setState({
            imageBanner : {
                label : null,
                imgsrc : "http://",
                href : "http://",
            },
            htmlBanner : {
                label : null,
                text : null,
            },
            tagReplacer : {
                label : null,
                text : null,
            },
            savingUserModule : false,
        });
    }

    handleCheckSavingUserModule(e) {
        this.setState({savingUserModule: e.target.checked});
    }

    handleUpdateImageBanner() {

        const { handleUpdateModule, handlePopupClose, module } = this.props;
        const { imageBanner, savingUserModule } = this.state;

        handleUpdateModule(module, imageBanner, savingUserModule);
        this.reInit();
        handlePopupClose();
    }

    handleUpdateHtmlBanner() {

        const { handleUpdateModule, handlePopupClose, module } = this.props;
        const { htmlBanner, savingUserModule } = this.state;

        handleUpdateModule(module, htmlBanner, savingUserModule);
        this.reInit();
        handlePopupClose();
    }

    handleUpdateTagReplacer() {

        const { handleUpdateModule, handlePopupClose, module } = this.props;
        const { tagReplacer, savingUserModule } = this.state;

        handleUpdateModule(module, tagReplacer, savingUserModule);
        this.reInit();
        handlePopupClose();
    }

    handleLabelChange(e, propertyName ) {

        this.setState(update(this.state, {
            [propertyName]: {
                label : {
                    $set : e.target.value,
                }
            }
        }));
    }

    handleImgSrcChange(e) {

        this.setState(update(this.state, {
            imageBanner: {
                imgsrc : {
                    $set : e.target.value,
                }
            }
        }));
    }

    handleHrefChange(e) {

        this.setState(update(this.state, {
            imageBanner: {
                href : {
                    $set : e.target.value,
                }
            }
        }));
    }

    handleTextChange(e, propertyName) {

        this.setState(update(this.state, {
            [propertyName]: {
                text : {
                    $set : e.target.value,
                }
            }
        }));
    }

    handleBlockIpChange(e) {
        this.setState({blockIp: e.target.checked});
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.module !== null){

            let module = nextProps.module;

            if(module.parameters === ""){
                this.reInit();
            }else{
                switch(module.handler) {
                    case "SB_Banner_withImage" :
                        this.setState({
                            imageBanner: {
                                label : module.parameters.label,
                                imgsrc : module.parameters.imgsrc,
                                href : module.parameters.href,
                            }
                        });
                        break;
                    case "SB_Banner_withCode" :
                        this.setState({
                            htmlBanner : {
                                label : module.parameters.label,
                                text : module.parameters.text,
                            },
                        });
                        break;
                    case "SB_Replacer" :
                        this.setState({
                            tagReplacer : {
                                label : module.parameters.label,
                                text : module.parameters.text,
                            }
                        });
                        break;
                }
            }

        }

    }

    handleEditModulePopup() {

        this.reInit();
        this.props.handlePopupClose();
    }

    render() {

        const { isEditSidebarModuleOpened, module } = this.props;

        if(module === null)
            return null;

        let handlerForm = '';
        let marginTop = '-199px';
        switch(module.handler) {
            case "SB_Banner_withImage" :
                handlerForm = this.renderBannerWithImageHandler();
                marginTop = '-199px';
                break;
            case "SB_Banner_withCode" :
                handlerForm = this.renderBannerWithCodeHandler();
                marginTop = '-196px';
                break;
            case "SB_Replacer" :
                handlerForm = this.renderTagReplacerHandler();
                marginTop = '-195px';
                break;
        }


        return (
            <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: marginTop, zIndex: 10, display: isEditSidebarModuleOpened?'block':'none'}}>
                <div className="inner_blog_layer inner_blog_layer1">
                    {handlerForm}
                </div>
            </div>
        );
    }

    renderBannerWithImageHandler() {

        const { imageBanner } = this.state;


        return (<form>
            <div className="cont_layer imgbnr_layer">
                <strong className="tit_popup">이미지 배너출력</strong>
                <label className="lab_tf">
                    <span className="txt_popup">이름</span>
                    <input type="text" className="tf_blog" ref="module" value={imageBanner.label} onChange={(e) => this.handleLabelChange(e, 'imageBanner')}/>
                </label>
                <label className="lab_tf">
                    <span className="txt_popup">이미지 URL</span>
                    <input type="text" className="tf_blog" value={imageBanner.imgsrc} onChange={(e) => this.handleImgSrcChange(e)}/>
                </label>
                <label className="lab_tf">
                    <span className="txt_popup">연결할 URL</span>
                    <input type="text" className="tf_blog" value={imageBanner.href} onChange={(e) => this.handleHrefChange(e)}/>
                </label>
                <div className="bundle_check">
                    <div className="check_blog">
                        <input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={false} onChange={this.handleCheckSavingUserModule}/>
                            <label htmlFor="inpCheck1" className="lab_check">
                                <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
                                <span className="txt_check">사용자 모듈에 저장</span>
                            </label>
                    </div>
                </div>
            </div>
            <div className="fld_btn">
                <button type="button" className="btn_cancel" onClick={this.handleEditModulePopup}>취소</button>
                <button type="button" className={classnames('btn_default', {btn_off : ((imageBanner.imgsrc === 'http://') && (imageBanner.href === 'http://'))})} disabled={((imageBanner.imgsrc === 'http://') && (imageBanner.href === 'http://'))} onClick={this.handleUpdateImageBanner}>확인</button>
            </div>
        </form>

        );

    }

    renderBannerWithCodeHandler() {

        const { htmlBanner } = this.state;
        return (<form >
            <div className="cont_layer">
                <strong className="tit_popup">HTML 배너출력</strong>
                <label className="lab_tf">
                    <span className="txt_popup">이름</span>
                    <input type="text" className="tf_blog" ref="module" value={htmlBanner.label} onChange={(e) => this.handleLabelChange(e, 'htmlBanner')}/>
                </label>
                <div className="lab_tf">
                    <span className="txt_popup">HTML 소스</span>
                    <textarea className="tf_blog tf_decoration" onChange={(e) => this.handleTextChange(e, 'htmlBanner')}>{htmlBanner.text}</textarea>
                </div>
                <div className="bundle_check">
                    <div className="check_blog">
                        <input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={false} onChange={this.handleCheckSavingUserModule}/>
                            <label htmlFor="inpCheck1" className="lab_check">
                                <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
                                <span className="txt_check">사용자 모듈에 저장</span>
                            </label>
                    </div>
                </div>
            </div>
            <div className="fld_btn">
                <button type="button" className="btn_cancel" onClick={this.handleEditModulePopup}>취소</button>
                <button type="button" className={classnames('btn_default', {btn_off : !htmlBanner.text})} disabled={!htmlBanner.text} onClick={this.handleUpdateHtmlBanner}>확인</button>
            </div>
        </form>);
    }

    renderTagReplacerHandler() {

        const { tagReplacer } = this.state;

        return (<form>
            <div className="cont_layer">
                <strong className="tit_popup">태그 입력기</strong>
                <label className="lab_tf">
                    <span className="txt_popup">이름</span>
                    <input type="text" className="tf_blog" ref="module" value={tagReplacer.label} onChange={(e) => this.handleLabelChange(e, 'tagReplacer')}/>
                </label>
                <div className="lab_tf">
                    <span className="txt_popup">치환자</span>
                    <textarea className="tf_blog tf_decoration" onChange={(e) => this.handleTextChange(e, 'tagReplacer')}>{tagReplacer.text}</textarea>
                </div>
                <div className="bundle_check">
                    <div className="check_blog">
                        <input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={false} onChange={this.handleCheckSavingUserModule}/>
                            <label htmlFor="inpCheck1" className="lab_check">
                                <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
                                <span className="txt_check">사용자 모듈에 저장</span>
                            </label>
                    </div>
                </div>
            </div>
            <div className="fld_btn">
                <button type="button" className="btn_cancel" onClick={this.handleEditModulePopup}>취소</button>
                <button type="button" className={classnames('btn_default', {btn_off : !tagReplacer.text})} disabled={!tagReplacer.text} onClick={this.handleUpdateTagReplacer}>확인</button>
            </div>
        </form>);

    }
}

export default EditModulePopup;
